import React, { memo } from 'react'
import styles from './index.less'
import CustomNodeWrapper from '../../configuration/wrapper'
import type { OutputNodeData } from '../types'
import type { ComponentType } from 'react'
import type { NodeProps } from 'reactflow'

function OutputNodeRender({ data, selected }: NodeProps<OutputNodeData>) {
  return (
    <CustomNodeWrapper nodeData={data} selected={selected}>
      <span className={`${styles.nodeText}`}>{data.nodeName}</span>
    </CustomNodeWrapper>
  )
}

const OutputNode: ComponentType<NodeProps<OutputNodeData>>
  = memo(OutputNodeRender)

export default OutputNode
